(() => {
  const normalize = (value) => (value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’'`´-]/g, '')
    .replace(/\s+/g, ' ');

  const canonicalTerm = (value) => {
    const term = normalize(value);
    const synonyms = new Map([
      ['kaba', 'Kaaba'],
      ['kabaa', 'Kaaba'],
      ['ka ba', 'Kaaba'],
      ['kabaah', 'Kaaba'],
      ['al aqsa', 'Al-Aqsa'],
      ['alaqsa', 'Al-Aqsa'],
      ['dome du rocher', 'Dôme du Rocher'],
      ['dome rocher', 'Dôme du Rocher']
    ]);
    return synonyms.get(term) || null;
  };

  const normalizeForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    const canonical = canonicalTerm(input.value);
    if (canonical) input.value = canonical;
  };

  document.addEventListener('submit', (event) => normalizeForm(event.target), true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const input = event.target instanceof Element ? event.target.closest('input[name="q"]') : null;
    if (!input) return;
    const form = input.closest('form');
    normalizeForm(form);
  }, true);
})();
